import { render, staticRenderFns } from "./AppBreadcumbItem.vue?vue&type=template&id=efe22460"
import script from "./AppBreadcumbItem.vue?vue&type=script&lang=js"
export * from "./AppBreadcumbItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./breadcrumb.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Fdash-webapp%2Fdash-webapp%2Fsrc%2Fcomponents%2Fproject%2Fui%2FAppBreadcrumb%2FAppBreadcumbItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports